import axiosInstance from "../../setupAxios";
import { IWork } from "../../repertoire/types/IWork";
import { IAddWorkAttachmentModel } from "../types/IAddAttchmentWorkModel";
import { IAttachedFile } from "../types/IAttachedFile";
import { IRemoveBlobAttachmentBase } from "../../repertoire/types/IRemoveBlobAttachmentBase";
import { IWorkContributor } from "../../repertoire/types/IWorkContributor";
import { IWorkDetailsQuery } from "../../membersportal/types/IWorkDetailsQuery";
import { IMemberWorkStatus } from "../../membersportal/types/IMemberWorkStatus";
import {
    IMemberStatementDistributionPool,
    IMemberStatementPaymentRunWork,
    IMemberStatementPaymentSummaryDetails,
    IMemberStatementUsageDetails,
    IMemberStatementWork
} from "../../membersportal/types/IMemberStatementSearchResult";
import { ICreatePackageFromCriteriaRequest } from "../../membersportal/types/ICreatePackageFromCriteriaRequest";
import { IPowerBIEmbedParams } from "../../memberspo../../membersportal/types/IPowerBIEmbedParams";
import { IProductCore } from "../../repertoire/types/IProductCore";
import { IUsageGroup } from "../../repertoire/types/usageTypes/IUsageGroup";
import { IAgreement } from "../../repertoire/types/IAgreement";
import { IAddAgreementAttachmentModel } from "../types/IAddAttchmentAgreementModel";
import { IRemoveAgreementAttachment } from "../../repertoire/types/IRemoveAgreementBlobAttachment";
import { IMembersPortalRoleAssignment } from "../types/IMembersPortalRoleAssignment";
import { MembersPortalRoles } from "../types/MembersPortalRoles";
import { MEMBERS_PORTAL } from "../../accounts/Consts";
import { IRegisteredWorkSearchQuery } from "../../membersportal/types/IRegisteredWorkSearchQuery";
import { EntityType } from "../../repertoire/types/EntityType";
import { IAddUsageAttachmentModel } from "../types/IAddUsageAttachmentModel";
import { IRemoveBlobModel } from "../types/IRemoveBlobModel";


export class MembersPortalService {

    static saveDraftWork(updatedWork: IWork): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post('membersPortalWork/save/', updatedWork)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static saveDraftSetLists(updatedSetList: IProductCore): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post('membersPortalSetList/save/', updatedSetList)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static saveDraftLivePerformance(updatedLivePerformance: IUsageGroup): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post('membersPortalLivePerformance/SaveNewUsageGroup/', updatedLivePerformance)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static saveDraftAgreement(updatedAgreement: IAgreement, postAgreement?: boolean): Promise<any> {
        updatedAgreement.notes.forEach((note, index) => {
            note.notesID = -1 - index;
        });
        return new Promise<any>((resolve, reject) => {
            const url: string = "membersPortalAgreement/save/" + (postAgreement ? "true" : "false");
            axiosInstance
                .post(url, updatedAgreement)
                .then(res => {
                    res.data.agreement.societyAffiliation = updatedAgreement.societyAffiliation;
                    res.data.agreement.agreementAdminIP.forEach((assignee: any, index: number) => {
                        assignee.societyAffiliation = updatedAgreement.agreementAdminIP[index].societyAffiliation;
                    });
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }


    static deleteWork(workId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .delete("membersPortalWork/delete/" + workId)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static deleteSetList(setListId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .delete("membersPortalWork/delete/" + setListId)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static saveRegisteredWork(updatedRegisteredWork: IWork): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post('registeredWork/save/', updatedRegisteredWork)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static deleteRegisteredWork(workId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .delete("registeredWork/delete/" + workId)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        })
    }

    static removeWorkAttachment(model: IAddWorkAttachmentModel): Promise<boolean> {
        const url: string = "membersPortalWork/removeattachment"
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }

    static deleteLivePerformanceBlob(model: IRemoveBlobModel): Promise<boolean> {
        const url: string = "membersPortalLivePerformance/DeleteBlob";
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(!!res.data)
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }

    static removeLivePerformanceAttachment(model: IAddUsageAttachmentModel): Promise<boolean> {
        const url: string = "membersPortalLivePerformance/removeattachment";
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    if (res?.data === "" || res?.data == null) {
                        resolve(true);
                    } else {
                        resolve(!!res.data);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }

    static addAgreementAttachmentRepertoire(model: IAddAgreementAttachmentModel): Promise<IAttachedFile> {
        const url: string = "membersPortalAgreement/addAttachment"
        return new Promise<IAttachedFile>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }

    static removeAgreementAttachment(model: IAddAgreementAttachmentModel): Promise<boolean> {
        const url: string = "membersPortalAgreement/removeattachment"
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    if (res?.data === "" || res?.data == null) {
                        resolve(true);
                    } else {
                        resolve(!!res.data);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }


    static addAttachmentRepertoire(model: IAddWorkAttachmentModel): Promise<IAttachedFile> {
        const url: string = "membersPortalWork/addAttachment"
        return new Promise<IAttachedFile>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        })
    }



    static removeWorkBlobAttachment(model: IRemoveBlobAttachmentBase): Promise<boolean> {
        const url: string = "membersPortalWork/RemoveBlobAttachment";
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(res.data);
                })
                .catch((err => {
                    console.log(err);
                    reject(err);
                }))
        })
    }

    static removeAgreementBlobAttachment(model: IRemoveAgreementAttachment): Promise<boolean> {
        const url: string = "membersPortalAgreement/RemoveBlobAttachment";
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post(url, model)
                .then(res => {
                    resolve(res.data);
                })
                .catch((err => {
                    console.log(err);
                    reject(err);
                }))
        })
    }

    static getContributors(searchQuery: IWorkDetailsQuery): Promise<IWorkContributor[]> {
        const {
            workIDs,
            dataSource,
            setType,
            setTypeGroup,
            contributorTypesToShow
        } = searchQuery;
        return new Promise<IWorkContributor[]>((resolve, reject) => {
            axiosInstance
                .post("membersPortalWork/GetWorkContributors", {
                    workIDs: workIDs.map(v => v.toString()),
                    dataSource: dataSource,
                    setType: setType,
                    setTypeGroup: setTypeGroup,
                    contributorTypesToShow: contributorTypesToShow
                })
                .then(response => {
                    const workContributors: IWorkContributor[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];
                        if (data.mechanicalShare === -1)
                            data.mechanicalShare = '';
                        if (data.performingShare === -1)
                            data.performingShare = '';
                        if (!workContributors.includes(data)) {
                            workContributors.push(data)
                        }
                    }

                    resolve(workContributors);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    static getStatus(searchQuery: IWorkDetailsQuery): Promise<IMemberWorkStatus[]> {
        const {
            workIDs,
            dataSource,
            setTypeGroup,
        } = searchQuery;
        return new Promise<IMemberWorkStatus[]>((resolve, reject) => {
            axiosInstance
                .post("membersPortalWork/GetWorkStatus", {
                    workIDs: workIDs.map(v => v.toString()),
                    dataSource: dataSource,
                    setTypeGroup: setTypeGroup,
                    setType: null,
                    contributorTypesToShow: null
                })
                .then(response => {
                    const workStatus: IMemberWorkStatus[] = [];
                    for (let workID in response.data) {
                        const memberWorkStatus: IMemberWorkStatus = {
                            workID: Number(workID),
                            workStatus: response.data[workID]
                        };
                        workStatus.push(memberWorkStatus);
                    }
                    resolve(workStatus);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    // TODODYL: Delete
    static getStatementPaymentRunWorks(paymentRunID: number, userNameNumber: string): Promise<IMemberStatementPaymentRunWork[]> {
        return new Promise<IMemberStatementPaymentRunWork[]>((resolve, reject) => {
            axiosInstance
                .post("MembersPortalStatement/StatementWorks", {
                    paymentRunID: paymentRunID.toString(),
                    type: null,
                    status: null,
                    paymentRunDateFrom: null,
                    paymentRunDateTo: null,
                    userNameNumber
                })
                .then(response => {
                    const paymentRunWorks: IMemberStatementPaymentRunWork[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const work = response.data[x];
                        let workSearchResultItem: IMemberStatementPaymentRunWork = {
                            workNumber: work.workNumber,
                            ipiNameNumber: work.ipiNameNumber,
                            ipName: work.ipName,
                            title: work.title,
                            sharePercentage: work.sharePercentage,
                            amount: work.amount,
                            distributionID: work.distributionID,
                            distributionCode: work.distributionCode,
                            poolID: work.poolID,
                            poolCode: work.poolCode,
                            usageDetails: work.usageDetails

                        }
                        paymentRunWorks.push(workSearchResultItem);
                    }
                    resolve(paymentRunWorks);
                })
                .catch(response => {
                    reject(response);
                })
        });
    }

    static getStatementDistributionPools(paymentRunID: number, userNameNumber: string): Promise<IMemberStatementDistributionPool[]> {
        return new Promise<IMemberStatementDistributionPool[]>((resolve, reject) => {
            axiosInstance
                .get(`MembersPortalStatement/StatementDistributionPools/${paymentRunID}/${userNameNumber}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response);
                })
        });
    }

    static getStatementWorks(
        paymentRunID: number,
        userNameNumber: string,
        distribution: string,
        pool: string,
        segment: string,
        continuationToken?: string,
        pageSize?: number
    ): Promise<{ continuationToken?: string, rows: IMemberStatementWork[] }> {
        return new Promise<{ continuationToken?: string, rows: IMemberStatementWork[] }>((resolve, reject) => {
                const baseUrl = `MembersPortalStatement/StatementWorks/${paymentRunID}/${userNameNumber}/${distribution}`;

                const url = baseUrl;

            const params = {
                continuationToken,
                pageSize,
                    pool,
                ...(segment ? { segment } : {})
            };

            axiosInstance
                .get(
                    url,
                    { params }
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getStatementUsageDetails(
        paymentRunID: number,
        userNameNumber: string,
        distribution: string,
        pool: string,
        segment: string | undefined,
        statementLineID: string,
        continuationToken?: string,
        pageSize?: number
    ): Promise<{ continuationToken?: string, rows: IMemberStatementUsageDetails[] }> {
        return new Promise((resolve, reject) => {
            axiosInstance
                .get(
                    'MembersPortalStatement/StatementUsageDetails',
                    {
                        params: {
                            paymentRunID,
                            userNameNumber,
                            distribution,
                            pool,
                            ...(segment ? { segment } : {}),
                            statementLineID,
                            ...(continuationToken ? { continuationToken } : {}),
                            ...(pageSize ? { pageSize } : {})
                        }
                    }
                )
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    static getStatementPaymentSummary(paymentRunID: number): Promise<IMemberStatementPaymentSummaryDetails> {
        return new Promise<IMemberStatementPaymentSummaryDetails>((resolve, reject) => {
            axiosInstance
                .get(`MembersPortalStatement/StatementPaymentSummary/${paymentRunID}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response);
                })
        });
    }

    static getPowerBIEmbed(reportId: string, queryParameter: string): Promise<IPowerBIEmbedParams> {
        return new Promise<IPowerBIEmbedParams>((resolve, reject) => {
            axiosInstance
                .get("MembersPortalStatement/StatementReport", {
                    params: {
                        reportid: reportId,
                        queryParameter: queryParameter
                    }
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response);
                })
        });
    }

    static fetchMembersPortalUserRoles(portalType: string): Promise<Record<string, IMembersPortalRoleAssignment>> {
        return new Promise((resolve, reject) => {
            axiosInstance
                .get("MembersPortalUserRole/GetCachedRolesForUser", {
                    params: {
                        portalType: portalType === MEMBERS_PORTAL ? 2 : 1
                    }
                })
                .then(res => resolve(res.data))
                .catch(err => {
                    reject(err);
                });
        });
    }

    static hasPermissionForMenu(menuLabel: string, requiredRole: MembersPortalRoles): boolean {
        const rolesJson = sessionStorage.getItem("membersPortalUserRoles");
        if (!rolesJson) return false;

        const roles: Record<string, string> = JSON.parse(rolesJson);

        const menuPermissionMap: Record<string, string> = {
            cases: "myCases",
            openNewCase: "myCases",
            memberStatementsAnalytics: "statementsAnalytics",
        };

        const effectiveMenuLabel = menuPermissionMap[menuLabel] ?? menuLabel;
        const roleName = roles[effectiveMenuLabel];

        if (!roleName) return false;

        const userRole = MembersPortalRoles[roleName as keyof typeof MembersPortalRoles];
        if (userRole === undefined) return false;

        return userRole >= requiredRole;
    }

    public static createPackageFromCriteria(userName: string, criteria: IRegisteredWorkSearchQuery): Promise<any> {
        const normalizedCriteria = {
            title: criteria.title,
            status: criteria.status,
            workNumber: criteria.workNumber,
            artist: criteria.artist,
            ipNumber: criteria.ipNumber,
            ipName: criteria.ipName,
            dataSource: criteria.dataSource,
            currentUserNameNumber: criteria.currentUserNameNumber,
            contributor: criteria.contributor,
            fromRegistrationDate: criteria.fromRegistrationDate,
            toRegistrationDate: criteria.toRegistrationDate,
            includeMyWorksRegisteredViaOtherChannels: criteria.includeMyWorksRegisteredViaOtherChannels,
            includeMyWorksRegisteredAllMyAccounts: criteria.includeMyWorksRegisteredAllMyAccounts,
            selectedAgreementIDs: criteria.selectedAgreementIDs,
        };

        const request: ICreatePackageFromCriteriaRequest = {
            userName,
            entityType: "Works",
            searchCriteriaJson: JSON.stringify(normalizedCriteria),
            isSearchAllMyAccounts: criteria.includeMyWorksRegisteredAllMyAccounts,
        };

        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post("Package/CreatePackageFromCriteria", request)
                .then(resolve)
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static createCueSheetPackageFromCriteria(userName: string, isSearchAllMyAccounts: boolean): Promise<any>
    {
        const request: ICreatePackageFromCriteriaRequest = {
            userName,
            entityType: EntityType.Products,
            searchCriteriaJson: "{}",
            isSearchAllMyAccounts,
        };

        return axiosInstance.post("Package/CreatePackageFromCriteria", request);
    }
}
